import { render, staticRenderFns } from "./RemoveContractorDisabledIcon.vue?vue&type=template&id=667a0cbe"
import script from "./RemoveContractorDisabledIcon.vue?vue&type=script&lang=ts"
export * from "./RemoveContractorDisabledIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports